/**************************************************
 * Nombre:       Formacion_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from "../../../Recursos/fondo_contactos.png";
import {CONTACTOS, NEGRITA} from "../../../Constantes";
import Tarjeta_Docente from "../../Tarjetas/Tarjeta_Docente";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../../Utilidades/irUrl";
import {useEffect, useState} from "react";

const Formacion_Contactos = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const [profes, setProfes] = useState([])

    useEffect(() => {

        if (item.profesores) {
            setProfes(item.profesores)
        }

    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start', p: sCell ? 3 : 6}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={4}
                >

                    {profes.map((item, index) => (
                        <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Docente item={item}/>
                        </Grid>
                    ))}

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        background: `linear-gradient(180deg, rgba(48, 51, 118, 0.85) 0%, rgba(48, 51, 118, 0.85) 100%), url(${fondo})`,
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                        p: sCell ? 4 : 6,
                        color: '#fff',
                        pb: 12

                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 32 : 40}}>Contactos</Typography>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        {CONTACTOS.map((contacto) => (
                            <Grid
                                onClick={() => irUrl(contacto.url)}
                                container size={{xs: 12, sm: 12, md: 12}}
                                sx={{
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                }}
                            >
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{borderBottom: 1, borderColor: '#fff', p: sCell ? 1 : 3}}
                                >

                                    <Typography sx={{fontSize: sCell ? 12 : 16}}>
                                        <span>
                                            <img src={contacto.img} width={18} height={'auto'}
                                                 style={{marginRight: 10, marginTop: 2, marginBottom: -2,}}/>
                                        </span>
                                        {contacto.descripcion}
                                    </Typography>

                                </Grid>
                            </Grid>
                        ))}

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                        <Typography sx={{fontWeight: 400, fontSize: sCell ? 14 : 16}}>
                            Bajo la dirección de Monica Yiseth López E, y en la coordinación de Mg. Melissa Rosales Dueñas,
                            abrimos nuestras puertas a profesionales y estudiantes que busquen capacitarse como
                            conciliadores expertos. <span style={{fontWeight: 600}}>¡Inicie su formación con nosotros hoy mismo!</span>
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Formacion_Contactos

const items = [
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
]